import type { AuditedEntityDto, PagedAndSortedResultRequestDto } from '@abp/ng.core';

export interface WineryImageDto {
  fileAttachmentId: number;
  order: number;
}

export interface CreateWineryDto {
  name: string;
  country?: string;
  region?: string;
  subregion?: string;
  shortDescription?: string;
  description?: string;
  address?: string;
  googleMapsUrl?: string;
  contactName?: string;
  email?: string;
  phone?: string;
  website?: string;
  imageUrl?: string;
  fileAttachmentId?: number;
  galleryFileIds: number[];
}

export interface GetWineryDto extends PagedAndSortedResultRequestDto {
  keyword?: string;
}

export interface UpdateWineryDto {
  name: string;
  country?: string;
  region?: string;
  subregion?: string;
  shortDescription?: string;
  description?: string;
  address?: string;
  googleMapsUrl?: string;
  contactName?: string;
  email?: string;
  phone?: string;
  website?: string;
  imageUrl?: string;
  fileAttachmentId?: number;
  galleryFileIds: number[];
}

export interface WineryDto extends AuditedEntityDto<number> {
  name?: string;
  country?: string;
  region?: string;
  subregion?: string;
  shortDescription?: string;
  description?: string;
  address?: string;
  googleMapsUrl?: string;
  contactName?: string;
  email?: string;
  phone?: string;
  website?: string;
  imageUrl?: string;
  isActive: boolean;
  fileAttachmentId?: number;
  images: WineryImageDto[];
}
